import { render, staticRenderFns } from "./Stock_Balance.vue?vue&type=template&id=23f892d4&scoped=true&"
import script from "./Stock_Balance.vue?vue&type=script&lang=js&"
export * from "./Stock_Balance.vue?vue&type=script&lang=js&"
import style0 from "./Stock_Balance.vue?vue&type=style&index=0&id=23f892d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f892d4",
  null
  
)

export default component.exports